import { useRouter } from 'next/router';
import clsx from 'clsx';

import useI18n from '@i18n';

import { HeaderProfileViewModel, HeaderNavContext, ResolvedNavItem } from '../../interfaces';
import { USER_MENU_TREE } from '../../config/trees';
import resolveNav from '../../utils/resolveNav';
import logout from '../../utils/logout';
import HeaderDropdown, { HeaderDropdownPositions } from '../HeaderDropdown';
import { IHeaderDropdownItem } from '../HeaderDropdown/HeaderDropdownItem';

import UserProfile from './UserProfile';

interface IUserMenuProps {
    profile: HeaderProfileViewModel;
    navContext: HeaderNavContext;
}

const mapToDropdownItem = (
    item: ResolvedNavItem,
    t: ReturnType<typeof useI18n>['t'],
): IHeaderDropdownItem => ({
    id: item.testId || item.id,
    label: t(item.labelKey),
    link: item.href,
    callback: item.action === 'logout' ? logout : undefined,
    className: item.action === 'logout' ? 'text-blueGray-300' : undefined,
});

const UserMenu: React.FC<IUserMenuProps> = ({ profile, navContext }) => {
    const { t } = useI18n('Base');
    const { pathname } = useRouter();
    const userMenuItems = resolveNav(USER_MENU_TREE, navContext, 'userMenu', pathname);
    const dropdownOptions = userMenuItems.map(item => mapToDropdownItem(item, t));
    const logoutItem = userMenuItems.find(item => item.action === 'logout');

    return (
        <HeaderDropdown
            options={dropdownOptions}
            dividerBeforeIds={logoutItem ? [logoutItem.testId || logoutItem.id] : undefined}
            position={HeaderDropdownPositions.right}
            itemClassName="py-1 text-blueGray-500"
            itemsListClassName="gap-[4px]"
        >
            {visible => (
                <div
                    className={clsx('flex items-center h-full cursor-pointer select-none', {
                        'shadow-4': visible,
                    })}
                >
                    {!visible && <div className="absolute w-px h-12 bg-blueGray-200" />}
                    <UserProfile profile={profile} />
                </div>
            )}
        </HeaderDropdown>
    );
};

export default UserMenu;
